export const accessRoutes = {
    0: "/outlet",
    1: "/",
    2: "/menu",
    3: "/discount",
    4: "/report",
    5: "/serving-type",
    6: "/ingredient-order",
    7: "/ingredient-report",
    8: "/payment-type",
    9: "/member",
    10: "/payment-management",
    11: "/whatsapp",
  };
  